module.exports = __webpack_public_path__ + "static/media/stockhausen_polymorph_3.238bf77f.jpg";